import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const DisplayType = (props) => {
  return (
    <FormGroup controlId="displayType">
      <Col componentClass={ControlLabel} sm={2}>
        Display Type
      </Col>
      <Col sm={10}>
            <select
              className="custom-select"
              onChange={props.handleChangeDisplayType}
              value={props.defaultDisplayType}>
              <option value="html">HTML</option>
              <option value="excel">Excel</option>
            </select>
      </Col>
    </FormGroup>
  )
}

DisplayType.propTypes = {
  handleChangeDisplayType: PropTypes.func,
  defaultDisplayType: PropTypes.string
};

export default DisplayType;



// WEBPACK FOOTER //
// ./src/app/components/displayType/DisplayType.js